// AI Generated Test
import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import {
    PagePerformancePageDetailsService,
} from '@client/app/modules/page-performance/services/page-performance-page-details/page-performance-page-details.service';
import {
    PagePerformanceReportRepoService,
} from '@client/app/services/api/page-performance/page-performance-report/page-performance-report-repo.service';
import {
    PagePerformanceRescanRepoService,
} from '@client/app/services/api/page-performance/page-performance-rescan-repo/page-performance-rescan-repo.service';
import {
    PagePerformanceScanService,
} from '@client/app/modules/page-performance/services/page-performance-scan/page-performance-scan.service';
import {
    AssignProfileService,
} from '@client/app/modules/page-performance/services/assign-profile/assign-profile.service';

@Component({
    selector: 'page-details-section-page-performance',
    standalone: false,
    template: `
        <div id="page-details-page-performance">
            <div class="page-details-section-header page-details-page-performance-header">
                <page-header
                    class="performance-header"
                    [header]="'Performance Scans' | translate"
                    subHeader="{{getSubHeader()}}"
                    [icon]="['MENUES', 'PAGE_PERFORMANCE'] | monIcons"
                    [subHeaderTooltipEnable]="false"
                    panelClass="row"
                    panelLeftClass="col-16 col-md-12 col-lg-10 col-lg-8 pl-6 pr-0"
                    panelRightClass="col-32 col-md-36 col-lg-38 pl-0 pr-6">
                    <page-header-content>
                        <div class="page-performance-actions-group d-flex justify-content-end">
                            <page-performance-profile-dropdown
                                class="flex-grow-1"
                                *ngIf="page"
                                [page]="page">
                            </page-performance-profile-dropdown>
                            <button
                                class="btn btn-border-radius btn-secondary page-performance-rescan-btn ml-2"
                                [ngbTooltip]="'The scan can take a few minutes to finalise, depending on the size of the page' | translate"
                                triggers="focus hover"
                                placement="left"
                                (click)="performanceRescan()"
                                [disabled]="!canRescan"
                                *ngIf="canUseOnDemandScan() && profile !== null">
                                <span *ngIf="canRescan" translate>Rescan</span>
                                <span [ngClass]="{'fas fa-sync fa-spin': !canRescan}" aria-hidden="true"></span>
                                <br>
                                <span *ngIf="!canRescan && !rescanning" translate>Checking</span>
                                <span *ngIf="!canRescan && rescanning" translate>Rescanning</span>
                            </button>
                        </div>
                    </page-header-content>
                </page-header>
            </div>
            <div class="page-details-section-body">
                <div class="row align-items-stretch max-height" *ngIf="profile !== null">
                    <div class="col-16 col-md-12 col-lg-10 col-lg-8 page-details-sitemenu border-right pr-0">
                        <ul class="sidebar-nav">
                            <li>
                                <a [ngClass]="{'active': active === 'dashboard'}"
                                    class="link"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'page-details-page-performance-dashboard'}"
                                    role="button"
                                    (click)="active = 'dashboard'; $event.preventDefault()">
                                    <span class="fas fa-home fa-fw mr-2" aria-hidden="true"></span>
                                    <span translate>Dashboard</span>
                                </a>
                            </li>
                            <li>
                                <a [ngClass]="{'active': active === 'performance-opportunities'}"
                                    class="link"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'page-details-page-performance-opportunities'}"
                                    role="button"
                                    (click)="active = 'performance-opportunities'; $event.preventDefault()">
                                    <span
                                        class="fa-fw mr-2"
                                        [ngClass]="['PAGE_PERFORMANCE', 'PERFORMANCE', 'OPPORTUNITIES'] | monIcons"
                                        aria-hidden="true">
                                    </span>
                                    <span translate>Opportunities</span>
                                </a>
                            </li>
                            <li>
                                <a [ngClass]="{'active': active === 'performance-diagnostics'}"
                                    class="link"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'page-details-page-performance-diagnostics'}"
                                    role="button"
                                    (click)="active = 'performance-diagnostics'; $event.preventDefault()">
                                    <span
                                        class="fa-fw mr-2"
                                        [ngClass]="['PAGE_PERFORMANCE', 'PERFORMANCE', 'DIAGNOSTICS'] | monIcons"
                                        aria-hidden="true">
                                    </span>
                                    <span translate>Diagnostics</span>
                                </a>
                            </li>
                            <li>
                                <a [ngClass]="{'active': active === 'performance-history'}"
                                    class="link"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'page-details-page-performance-history'}"
                                    role="button"
                                    (click)="active = 'performance-history'; $event.preventDefault()">
                                    <span
                                        class="fa-fw mr-2"
                                        [ngClass]="['PAGE_PERFORMANCE', 'PERFORMANCE', 'HISTORY'] | monIcons"
                                        aria-hidden="true">
                                    </span>
                                    <span translate>History</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-32 col-md-36 col-lg-38 bg-light-grey">
                        <mon-spinner [loading]="loadingReport()">
                            <page-performance-page-details-dashboard
                                *ngIf="!loadingReport() && active === 'dashboard' && report"
                                [page]="page"
                                (onResultChange)="onResultChange($event.lastCheck)"
                                (goToSection)="goToActive($event.active)"
                                [report]="report"
                                [profile]="profile">
                            </page-performance-page-details-dashboard>
                            <page-performance-page-details-opportunities
                                *ngIf="!loadingReport() && active === 'performance-opportunities' && report">
                            </page-performance-page-details-opportunities>
                            <page-performance-page-details-diagnostics
                                *ngIf="!loadingReport() && active === 'performance-diagnostics' && report">
                            </page-performance-page-details-diagnostics>
                            <page-performance-page-details-history
                                *ngIf="!loadingReport() && active === 'performance-history' && report"
                                [profile]="profile"
                                [page]="page">
                            </page-performance-page-details-history>
                            <div *ngIf="noData" class="row min-height mt-4">
                                <div class="col-48">
                                    <div class="card panel-monsido-card min-height">
                                        <h2 class="text-center font-weight-300 text-grey py-6" translate>
                                            No scan has yet been performed. Please check back later.
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </mon-spinner>
                    </div>
                </div>
                <div class="pt-4 no-data-card text-center" *ngIf="!hasProfile()">
                    <h2 class="font-weight-300 text-grey py-8" translate>
                        This page has not been assigned to the Performance Module
                    </h2>
                    <button
                        class="btn btn-border-radius btn-secondary font-size-1-3 font-weight-400"
                        type="button"
                        (click)="assignProfile()"
                        *ngIf="['customer_admin'] | role"
                        translate>
                        Assign to the Performance Module
                    </button>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionPagePerformanceComponent implements OnInit, OnDestroy {
    @Input() page: any;
    @Input() active: any;

    private pagePerformancePageDetailsService = inject(PagePerformancePageDetailsService);
    private pagePerformanceReportRepoService = inject(PagePerformanceReportRepoService);
    private pagePerformanceRescanRepoService = inject(PagePerformanceRescanRepoService);
    private pagePerformanceScanService = inject(PagePerformanceScanService);
    private monEventsService = inject(MonEventService);
    private dateTimeService = inject(DateTimeService);
    private translateService = inject(TranslateService);
    private sessionService = inject(SessionService);
    private pagePerformanceAssignProfileService = inject(AssignProfileService);

    scanStatusSubscription: any = null;
    profile: any = null;
    noData: boolean = false;
    canRescan: boolean = false;
    rescanning: boolean = false;
    ProfileSetupFinished: boolean = false;
    onSelectProfileID: any;
    afterProfileSetupID: any;
    beforeProfileSetupID: any;
    report: any;
    lastCheck: any;
    intervalId: any;

    ngOnInit (): void {
        this.scanStatusSubscription = null;
        this.active = this.selectSection();
        this.profile = null;
        this.noData = false;
        this.canRescan = false;
        this.rescanning = false;
        this.ProfileSetupFinished = false;
        this.setupListeners();
    }

    ngOnDestroy (): void {
        this.disposeScanStatus();
        this.monEventsService.remove(this.onSelectProfileID);
        this.monEventsService.remove(this.afterProfileSetupID);
        this.monEventsService.remove(this.beforeProfileSetupID);
    }

    goToActive (active: any): void {
        this.active = active;
    }

    onResultChange (lastCheck: any): void {
        this.lastCheck = lastCheck;
    }

    getSubHeader (): string {
        let lastCheckTime: string;
        if (this.lastCheck) {
            lastCheckTime = this.dateTimeService.formatBrowserLocalized(this.lastCheck.scanned_at, 'LL LTS');
        } else {
            lastCheckTime = this.translateService.getString('None');
        }
        return this.translateService.getString('Last check: [[lastCheckTime]]', {
            lastCheckTime: lastCheckTime,
        });
    }

    performanceRescan (): void {
        this.pagePerformanceScanService.performanceRescan(this.page, this.profile).then(() => {
            this.canRescan = false;
            this.rescanning = true;
            this.disposeScanStatus();
            this.runRescanInterval();
        }, () => {});
    }

    hasProfile (): boolean {
        return !this.ProfileSetupFinished || this.profile !== null;
    }

    loadingReport (): boolean {
        return this.hasProfile() && this.pagePerformancePageDetailsService.getLoadingReportStatus();
    }

    assignProfile (): void {
        this.pagePerformanceAssignProfileService.assignProfile(this.page);
    }

    canUseOnDemandScan (): boolean {
        return Boolean(this.sessionService.customer !== null && this.sessionService.customer.plan_traits.performance_tracking_on_demand_scan);
    }

    // PROTECTED

    private setupListeners (): void {
        this.onSelectProfileID = this.monEventsService.addListener('pagePerformanceSelectProfile', (profile: any) => {
            if (profile) {
                this.canRescan = false;
                this.disposeScanStatus();
                this.runRescanInterval();
                this.profile = profile;
                this.getReport();
            }
        });

        this.afterProfileSetupID = this.monEventsService.addListener('pagePerformanceAfterSelectProfile', () => {
            this.ProfileSetupFinished = true;
        });

        this.beforeProfileSetupID = this.monEventsService.addListener('pagePerformanceBeforeSelectProfile', () => {
            this.ProfileSetupFinished = false;
        });
    }

    private getReport (): void {
        this.noData = false;
        const params = {
            page_id: this.page.id,
            profile_id: this.profile.id,
        };
        this.monEventsService.run('pagePerformancePDBeforeSetReport');
        this.pagePerformanceReportRepoService.getAll(params)
            .then(
                (report: any) => {
                    this.report = report;
                    this.monEventsService.run('pagePerformancePDOnSetReport', this.report);
                    this.monEventsService.run('pagePerformanceUpdateAssignedProfile', this.page, this.profile);
                },
                () => {
                    this.report = null;
                    this.monEventsService.run('pagePerformancePDOnSetReport', this.report);
                    this.noData = true;
                },
            )
            .finally(() => {
                this.monEventsService.run('pagePerformancePDAfterSetReport');
            });
    }

    private selectSection (): string {
        const sections: string[] = [];
        const index = sections.indexOf(this.active);
        if (index === -1) {
            return 'dashboard';
        }
        return sections[index];
    }

    private runRescanInterval (): void {
        this.intervalId = setInterval(() => {
            this.getScanCollection().then(
                (scans: any[]) => {
                    /** It's safe to attempt a rescan if
                     * No Scan records were found
                     * Last scan record is finished
                     * The last attempted scan is more than an hour old
                     */
                    if (!scans || scans.length === 0) {
                        this.canRescan = true;
                        this.rescanning = false;
                        return;
                    }

                    // We should only allow a new report if a new scan has finished up
                    const isFetchTimeBefore = this.dateTimeService.isBefore(
                        this.dateTimeService.toUtcDate(this.report.fetchTime),
                        scans[0].created_at,
                    );
                    const scanContainsNewReport = !this.report || isFetchTimeBefore;

                    const isOneHourOld = this.dateTimeService.isAfter(
                        this.dateTimeService.substractDuration(undefined, 1, 'hours'),
                        scans[0].created_at,
                    );
                    this.canRescan = Boolean(
                        scans[0].status === 'finished' || isOneHourOld,
                    );

                    // Dispose of observable if this.canRescan is true
                    if (this.canRescan) {
                        this.rescanning = false;
                        this.disposeScanStatus();
                    }

                    if (this.canRescan && scanContainsNewReport) {
                        this.getReport();
                    }
                },
                () => {
                    // If the endpoint errored, we are gonna assume it is safe for the client to attempt a rescan
                    this.canRescan = true;
                    this.rescanning = false;
                    this.disposeScanStatus();
                },
            );
        }, 15000);
    }

    private disposeScanStatus (): void {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    private getScanCollection (): Promise<any> {
        const params = {
            page_id: this.page.id,
            profile_id: this.profile.id,
        };

        return this.pagePerformanceRescanRepoService.get(params, contextTokens.NO_GLOBAL);
    }
}
